import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const propTypes = {
	active: PropTypes.bool.isRequired,
	closeModal: PropTypes.func.isRequired,
	conago: PropTypes.array.isRequired
}

const ConagoReviewModal = (props) => {
	const {active, closeModal, conago} = props;
	return <div className={`modal${active ? ' is-active' : ''}`}>
		<div className="modal-background"/>
		<div className="modal-content">
			<div className="message">
				<div className="message-header">
					<p>Metas CONAGO seleccionadas</p>
					<button type="button" onClick={() => closeModal()} className="delete is-medium" aria-label="delete"></button>
				</div>
				<div className="message-body">
					<div className="content">
						<ul>
							{_.map(conago, (clause, k) => <li key={k}>{clause.name}</li>)}
						</ul>
					</div>
					<br/><br/>
					<div className="field is-grouped is-grouped-right">
						<div className="control">
							<button className="button is-info" type="button" onClick={() => closeModal()}>
								Cerrar
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
}

ConagoReviewModal.propTypes = propTypes;

export default ConagoReviewModal;


// WEBPACK FOOTER //
// ./src/elements/revision/widget/conago_modal.jsx